{
	"resourceType": "Questionnaire",
	"meta": {
		"profile": ["http://hl7.org/fhir/4.0/StructureDefinition/Questionnaire"]
	},
	"url": "http://reference-data.careconnect.be/api/fhir/Questionnaire/TIMED_CHAIR_STAND",
	"name": "TIMED_CHAIR_STAND",
	"language": "nl-BE",
	"status": "active",
	"publisher": "Corilus NV",
	"title": "Timed Chair Stand",
	"purpose": "Meet de spierkracht en functionele mobiliteit",
	"description": "Het meten van de tijd (in seconden) die nodig is om vijf keer achter elkaar op te staan en te gaan zitten.",
	"item": [
		{
			"linkId": "573-instructions",
			"text": "De te onderzoeken patiënt zit met de armen gekruist over de borstkas op een stoel met een rugleuning en zonder armleuningen. Hij wordt verzocht recht te staan en vijfmaal na elkaar zo snel mogelijk te gaan zitten zonder de armen te gebruiken. Het gebruik van een hulpmiddel is niet toegestaan. Een praktische proef is aanbevolen om de patiënt vertrouwd te maken met de test.",
			"type": "display"
		},
		{
			"linkId": "80200",
			"text": "Hoeveel seconden duurt het om de Timed Chair Stand uit te voeren?",
			"type": "integer",
			"required": true,
			"extension": [
				{
					"url": "http://hl7.org/fhir/StructureDefinition/questionnaire-unit",
					"valueCoding": {
						"system": "http://unitsofmeasure.org",
						"code": "s",
						"display": "seconds"
					}
				},
				{
					"url": "http://hl7.org/fhir/StructureDefinition/minValue",
					"valueInteger": 1
				}
			]
		}
	]
}
